import { publicClient, privateClient } from './client';
import { V2ProductResource } from './V2ProductResource';

const queryV2ProductResource = (pub: boolean) => new V2ProductResource(pub ? publicClient : privateClient);
export default queryV2ProductResource;
